export default __webpack_public_path__ + "static/media/KEBAB-BUSD.ffc17b53.png";